"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputTypeCodeToId = void 0;
const types_collection_1 = require("@dzambalaorg/types-collection");
exports.InputTypeCodeToId = {
    [types_collection_1.InputType.awaited]: 0,
};
//# sourceMappingURL=index.js.map